import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPeopleRemove"><Path d="M16 6.5C16 8.70914 14.2091 10.5 12 10.5C9.79086 10.5 8 8.70914 8 6.5C8 4.29086 9.79086 2.5 12 2.5C14.2091 2.5 16 4.29086 16 6.5Z" stroke="currentColor" strokeLinejoin="round"/><Path d="M13 20.5H4C4 16.0817 7.58172 12.5 12 12.5C13.0609 12.5 14.0736 12.7065 15 13.0815" stroke="currentColor"/><Path d="M20.5 15.5L18 18M18 18L15.5 20.5M18 18L15.5 15.5M18 18L20.5 20.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconPeopleRemove;
